import extractGraphqlPagination from './extractGraphqlPagination'
import extractV1ApiPagination from './extractV1ApiPagination'

export default {
  gqlv2: extractGraphqlPagination,
  apiv1: extractV1ApiPagination,
}
